import { useEffect, useRef } from 'react';
import smoothscroll from 'smoothscroll-polyfill';

export const useCustomScrollToTop = (customRef, behavior = 'smooth') => {
  const blockRef = customRef || useRef({});

  useEffect(() => {
    const body = document.getElementById('bodyWrapper');
    const innerDiv = body?.children[0];

    blockRef.current = {
      body,
      innerDiv,
    };
  }); // needs to run every time

  const goToTop = (withoutBehavior = false, offsetTopElement = 0, offset = 0) => {
    smoothscroll.polyfill();
    if (withoutBehavior) {
      return blockRef.current.body.scroll({ top: offsetTopElement - offset });
    }
    blockRef.current.body.scroll({
      top: offsetTopElement - offset,
      behavior,
    });
  };

  return { goToTop };
};
